import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout, LocaleProvider } from "./components/Layout";
import {
  AboutPage,
  AiSolutionsPage,
  CareersPage,
  CaseStudiesPage,
  CompaniesPage,
  CompanyDetailPage,
  ContactPage,
  DeepDomainPage,
  FaqPage,
  HomePage,
  HumanOrganicPage,
  InsightDetailPage,
  InsightsPage,
  LegalPage,
  NotFoundPage,
  OneTeamPage,
  SolutionsPage,
  WorkWithQuboPage,
} from "./pages/MarketingPages";

export default function App() {
  return (
    <BrowserRouter>
      <LocaleProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/solutions/ai" element={<AiSolutionsPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/companies/:slug" element={<CompanyDetailPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<InsightDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/work-with-qubo" element={<WorkWithQuboPage />} />
            <Route path="/deep-domain-experience" element={<DeepDomainPage />} />
            <Route path="/one-team-three-brands" element={<OneTeamPage />} />
            <Route path="/human-organic-thinking" element={<HumanOrganicPage />} />
            <Route path="/privacy-policy" element={<LegalPage />} />
            <Route path="/terms-of-service" element={<LegalPage />} />
            <Route path="/cookie-policy" element={<LegalPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </LocaleProvider>
    </BrowserRouter>
  );
}
